import { Pipe, PipeTransform } from '@angular/core';
import { FcListValidationService } from '../../generic';

@Pipe({
  name: 'isRequiredFindControlValidation'
})
export class IsRequiredFindControlValidationPipe implements PipeTransform {

  transform(controlName: string, fcListValidation: FcListValidationService, defaultValue = false): boolean {
    if (fcListValidation.validations[controlName]) {
      return !!fcListValidation.validations[controlName]?.IsRequired;
    }
    return defaultValue;
  }
}
